import type { WeeklyBriefStatus } from '@conversed/rest/src/contracts/weekly-brief/weekly-brief.enums';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { STATUS_CHIP_CLASSES, STATUS_LABEL_KEYS } from './weeklyBrief.utils';

type TProps = {
  status: WeeklyBriefStatus;
};

export const WeeklyBriefStatusChip: React.FC<TProps> = ({ status }) => {
  const { t } = useTranslation();

  return (
    <span
      className={`inline-block rounded-full px-2 py-0.5 text-tiny font-medium ${STATUS_CHIP_CLASSES[status]}`}>
      {t(STATUS_LABEL_KEYS[status])}
    </span>
  );
};
